import React from "react";
import { useNavigate } from "react-router-dom";

export default function Navbar() {
  const navigate = useNavigate();
  const [role, setRole] = React.useState(null);

  React.useEffect(() => {
    (async () => {
      try {
        const token = localStorage.getItem("token");
        const apiUrl = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");
        if (!token || !apiUrl) return;
        const res = await fetch(`${apiUrl}/me`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) return;
        const data = await res.json();
        setRole(data?.role || null);
      } catch {}
    })();
  }, []);

  const handleLogout = async () => {
    const token = localStorage.getItem("token");
    const apiUrl = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");
    try {
      if (token && apiUrl) {
        await fetch(`${apiUrl}/logout`, {
          method: "POST",
          headers: { Authorization: `Bearer ${token}` },
        });
      }
    } catch {}
    localStorage.removeItem("token");
    navigate("/login");
  };

  return (
    <nav
      style={{
        background: "linear-gradient(90deg, #23395d 60%, #2d4a7a 100%)",
        color: "#fff",
        padding: "0 0 0 32px",
        display: "flex",
        alignItems: "center",
        height: 64,
        fontWeight: 500,
        fontSize: 18,
        letterSpacing: 0.5,
        boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
      }}
    >
      <span style={{ fontWeight: 700, fontSize: 22, marginRight: 40 }}>
        COUNSELOR NOTES
      </span>
      <button style={btnStyle} onClick={() => navigate("/dashboard")}>
        Dashboard
      </button>
      <button style={btnStyle} onClick={() => navigate("/students")}>
        Students
      </button>
      <button style={btnStyle} onClick={() => navigate("/support-plans")}>
        Support Plans
      </button>
      <button style={btnStyle} onClick={() => navigate("/analysis")}>
        Analysis
      </button>
      <button style={btnStyle} onClick={() => navigate("/calendar")}>
        Calendar
      </button>
      <div
        style={{ marginLeft: "auto", display: "flex", alignItems: "center" }}
      >
        <button
          onClick={() => navigate("/add-student")}
          style={{
            background: "none",
            border: "1px solid rgba(255,255,255,0.6)",
            color: "#fff",
            marginRight: 12,
            fontWeight: 600,
            fontSize: 14,
            borderRadius: 6,
            padding: "6px 10px",
            cursor: "pointer",
          }}
        >
          Add Student
        </button>
        {role === "admin" && (
          <button
            onClick={() => navigate("/add-schools")}
            style={{
              background: "none",
              border: "1px solid rgba(255,255,255,0.6)",
              color: "#fff",
              marginRight: 12,
              fontWeight: 600,
              fontSize: 14,
              borderRadius: 6,
              padding: "6px 10px",
              cursor: "pointer",
            }}
          >
            Add Schools
          </button>
        )}
        {(role === "admin" ||
          role === "districtAdmin" ||
          role === "auditor") && (
          <button
            onClick={() => navigate("/admin-tools")}
            style={{
              background: "none",
              border: "1px solid rgba(255,255,255,0.6)",
              color: "#fff",
              marginRight: 12,
              fontWeight: 600,
              fontSize: 14,
              borderRadius: 6,
              padding: "6px 10px",
              cursor: "pointer",
            }}
          >
            Admin Tools
          </button>
        )}
        <button
          onClick={handleLogout}
          style={{
            background: "#fff",
            color: "#23395d",
            border: "none",
            borderRadius: 6,
            fontWeight: 700,
            fontSize: 16,
            padding: "8px 22px",
            cursor: "pointer",
            marginRight: 24,
          }}
        >
          Log Out
        </button>
      </div>
    </nav>
  );
}

const btnStyle = {
  color: "#fff",
  background: "none",
  border: "none",
  textDecoration: "none",
  marginRight: 32,
  font: "inherit",
  cursor: "pointer",
};
// Navbar component
